const defaultEditorPluginPreset = [
  "code",
  "strikeThrough",
  "highlight",
  "underline",
  "italic",
  "bold",
  "scrollTarget",
  "newline",
  "table",
  "anchor",
  "paragraph",
  "heading",
  "horizontalRule",
  "list"
];
export {
  defaultEditorPluginPreset
};
//# sourceMappingURL=presets.js.map
